export default __webpack_public_path__ + "static/media/CNo.72-0.dab18d6f.jpg";